import { Check, Plus } from "lucide-react";
import { useProfiles } from "@/context/ProfileContext";
import { useGuest } from "@/context/GuestContext";

export const MyListButton = ({ title, variant = "pill", testId = "my-list-toggle-btn" }) => {
  const { myList, toggleMyList } = useProfiles();
  const { isGuest, openAuth } = useGuest();
  const inList = myList.has(title.slug);
  const Icon = inList ? Check : Plus;
  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isGuest) return openAuth({ reason: "mylist" });
    toggleMyList(title.slug, title.title);
  };
  if (variant === "icon") {
    return (
      <button
        data-testid={testId}
        onClick={toggle}
        aria-label={inList ? "Remove from My List" : "Add to My List"}
              className={`grid h-9 w-9 place-items-center rounded-full border transition-colors ${inList ? "border-[#FFD86A] bg-[#D4AF37]/20 text-[#FFD86A]" : "border-[#D4AF37]/50 bg-[#050505]/60 text-[#F5C451] hover:border-[#FFD86A] hover:text-[#FFD86A]"}`}
      >
        <Icon className="h-4 w-4" />
      </button>
    );
  }
  return (
    <button data-testid={testId} data-in-list={inList} onClick={toggle} className="btn-ghost-gold px-3 sm:px-6 py-3 text-sm sm:text-base">
      <Icon className="h-5 w-5" /> {inList ? <><span className="sm:hidden">Added</span><span className="hidden sm:inline">In My List</span></> : "My List"}
    </button>
  );
};
